export interface PlatformMessageConfig {
  selected?: string;
  lifetime?: string;
}

// Rating 卡片标题配置
export const formatMessageIdConfig: Record<string, PlatformMessageConfig> = {
  selectedXbox: { selected: "Added Reviews" },
  xbox: { lifetime: "Lifetime Reviews" },
  playstation: { lifetime: "Lifetime Rating" },
};